import { LocalFileAttachment } from "../types/LocalFileAttachment";

export const PrepareFileToUpload = (file: LocalFileAttachment, formDataDefault?: FormData|null): FormData => {
    const formData = formDataDefault || new FormData();
    formData.append('file[]', file.filePointer);
    return formData;
};

export const ToLocalFileAttachments = (inputFile: any): LocalFileAttachment[] => {
    let fileId = Date.now();
    const fileArr: any[] = Array.from(inputFile);
    const newFiles: LocalFileAttachment[] = fileArr.map((filePointer: File, index: number) => { 
        const {
            name, size, type
        } = filePointer;
        const att: LocalFileAttachment = {
            id: 'file_' + fileId + '_' + index,
            name, size, type,
            filePointer
        };
        return att;
    });
    return newFiles;
};